module.exports = __webpack_public_path__ + "img/BBGL.29970acb.svg";